import React, { useState, useEffect } from 'react';
import '../App.css';
import './Contacto.css';
import 'mapbox-gl/dist/mapbox-gl.css';


export default function Contacto({ go }) {
  const [form, setForm] = useState({ nombre: '', mensaje: '', direcciones: [] });
  const [status, setStatus] = useState(null);

  function onChange(e) {
    const { name, value } = e.target;
    if (name.startsWith('direcciones-')) {
      const idx = Number(name.split('-')[1]);
      setForm((f) => {
        const arr = [...(f.direcciones || [])];
        arr[idx] = value;
        return { ...f, direcciones: arr };
      });
    } else {
      setForm({ ...form, [name]: value });
    }
  }

  useEffect(() => {
    try {
      const rs = localStorage.getItem('routeStops');
      if (rs) {
        const parsed = JSON.parse(rs);
        const addresses = parsed.map((s) => s.address);
        setForm((f) => ({ ...f, direcciones: addresses }));
      }
    } catch (e) {
    }
  }, []);

  function onSubmit(e) {
    e.preventDefault();

    // Solo incluye direcciones si de verdad hay contenido real (no vacías)
    const direccionesValidas = (form.direcciones || []).filter((d) => d && d.trim() !== '');

    const partesMensaje = [
      `Hola, mi nombre es ${form.nombre}.`,
      `Estoy interesado en solicitar un servicio de transporte.`,
      `Detalles: ${form.mensaje}.`,
    ];

    if (direccionesValidas.length > 0) {
      partesMensaje.push(`\nRuta:\nDirecciones: ${direccionesValidas.join(' | ')}`);
    }

    partesMensaje.push(`\nQuedo atento(a) a la cotización y disponibilidad. Muchas gracias.`);

    const mensajeWhatsApp = partesMensaje.join('\n');

    const numeroWhatsApp = '+573133432336';
    const mensajeEncoded = encodeURIComponent(mensajeWhatsApp);
    const urlWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${mensajeEncoded}`;

    window.open(urlWhatsApp, '_blank');

    setStatus({ type: 'success', text: `Gracias ${form.nombre || 'cliente'}, abriendo WhatsApp...` });
    setForm({ nombre: '', mensaje: '', direcciones: [] });
    setTimeout(() => setStatus(null), 4000);
  }

  return (
    <section className="contact-page">
      <div className="contact-wrapper">

        {/* HEADER */}
        <header className="contact-header">
          <h1>Contactenos</h1>
          <p>Déjanos tus datos o escríbenos directamente por WhatsApp.</p>
        </header>

        {/* CARD */}
        <div className="contact-card">

          {/* LEFT — Info + CTA (WhatsApp) */}
          <aside className="contact-info">
            <h3>¿Listo para tu envío?</h3>
            <p className="info-text">Si buscas un transporte puntual y seguro, cuéntanos las características del viaje y te ayudamos a cotizar y coordinar la mejor opción.</p>
            
              <a className="btn whatsapp-large"
              href="https://wa.me/+573133432336"
              target="_blank"
              rel="noopener noreferrer"
            >
              Escríbenos por WhatsApp
            </a>

            <ul className="contact-details">
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                +57 313 343 2336
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 6c0 1-1.4 1.9-4 3.7C15.5 11.3 13.6 13 12 13s-3.5-1.7-6-3.3C3.4 7.9 2 7 2 6" />
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                </svg>
                yucamo1@hotmail.com
              </li>
            </ul>
          </aside>

          <div
            className="contact-form-panel"
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img//contactenos/contactenos.jpg)` }}
            aria-label="Formulario de contacto sobre imagen"
          >
            <div className="form-overlay" aria-hidden="true"></div>

            <div className="form-card">
              <form className="contact-form" onSubmit={onSubmit}>
                {status && <div className={`status ${status.type}`}>{status.text}</div>}

                <div className="field">
                  <label>Nombre</label>
                  <input
                    name="nombre"
                    value={form.nombre}
                    onChange={onChange}
                    placeholder="Tu nombre completo"
                    required
                  />
                </div>

                <div className="field full">
                  <label>Mensaje</label>
                  <textarea
                    name="mensaje"
                    value={form.mensaje}
                    onChange={onChange}
                    placeholder="Cuéntanos sobre tu envío"
                    required
                  />
                </div>

                <div className="field full directions-group">
                  <label>Direcciones seleccionadas</label>
                  {form.direcciones && form.direcciones.length ? (
                    form.direcciones.map((d, i) => (
                      <div className="field" key={i}>
                        <label>{`Dirección ${i + 1}`}</label>
                        <input
                          name={`direcciones-${i}`}
                          value={d}
                          onChange={onChange}
                          placeholder={`Dirección ${i + 1}`}
                        />
                      </div>

                    ))
                  ) : (
                    <input readOnly placeholder="No hay direcciones seleccionadas" />
                  )}
                </div>
                <div className="modify-directions-link">
                  <button
                  className="btn primary"
                  onClick={() => go('route')}
                  >
                    Modificar direcciones
                   </button>
                </div>

                <div className="submit-row">
                  <button className="btn-submit" type="submit">
                    Enviar mensaje
                  </button>
                  
                    <a className="whatsapp-icon-btn"
                    href="https://wa.me/+573133432336"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Escribir por WhatsApp"
                    title="Escribir por WhatsApp"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm0 18.14a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.37c0-4.53 3.69-8.22 8.24-8.22 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.24 8.23z" />
                    </svg>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}